import React, { useState } from "react";
import { FaSpinner, FaTimes } from "react-icons/fa";
import { FiTrash2 } from "react-icons/fi";
import { toast } from "react-toastify";
import {
  deleteShopper,
} from "../../../redux/slices/shopperSlice";
import { useDispatch, useSelector } from "react-redux";
import { fetchVendors } from "../../../redux/slices/vendorsSlice";

export default function DeleteVendor({ id }) {
  const [showModal, setShowModal] = useState(false);
  const status = useSelector((state) => state.shopper?.statusDeleteShopper); 
  const dispatch = useDispatch();

  const handleDelete = async () => {
    try {
      await dispatch(deleteShopper(id)).unwrap();
      await dispatch(fetchVendors());
      toast.success("Vendor deleted successfully");
      setShowModal(false);
    } catch (error) {
      toast.error("Failed to delete user");
      console.error(error);
    }
  };

  return (
    <>
      <button
        type="button"
        onClick={() => setShowModal(true)}
        className="hover:shadow-lg"
      >
        <FiTrash2 className="text-xl hover:text-red-600" />
      </button>

      {showModal && (
        <>
          <div className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none">
            <div className="relative w-full max-w-md mx-auto my-6">
              <div className="border-0 rounded-lg p-6 shadow-lg bg-white relative flex flex-col outline-none focus:outline-none">
                <button
                  onClick={() => setShowModal(false)}
                  className="absolute top-3 right-3 text-gray-400 hover:text-gray-900"
                >
                  <FaTimes className="text-xl" />
                  <span className="sr-only">Close modal</span>
                </button>
                <h1 className="text-2xl text-center text-gray-800 font-semibold mb-4">
                  Confirm Deletion
                </h1>
                <p className="text-center text-gray-600 mb-6">
                  Are you sure you want to delete this vendor? This action
                  cannot be undone.
                </p>
                <div className="flex justify-center gap-4">
                  <button
                    onClick={() => setShowModal(false)}
                    className="px-4 py-2 text-sm font-semibold bg-gray-100 text-gray-700 rounded-lg"
                  >
                    Cancel
                  </button>
                  <button
                    onClick={handleDelete}
                    className="flex items-center gap-2 px-4 py-2 text-sm font-semibold bg-red-600 text-white rounded-lg"
                    disabled={status === "loading"}
                  >
                    {status === "loading" ? (
                      <>
                        <FaSpinner className="animate-spin" />
                        Deleting...
                      </>
                    ) : (
                      "Delete Vendor"
                    )}
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div className="fixed inset-0 bg-black opacity-25 z-40"></div>
        </>
      )}
    </>
  );
}
